import React, { memo, useMemo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { bindActionCreators } from 'redux';
import {
  mapStringCartToObject,
  getObjectValue,
  urlSearchParams,
} from '@utility/utills';
import { APP_CONFIG } from '@constants';
import getDeviceType from '@utility/deviceType';
import { TouchableDiv } from '@components/common/Touchable/index';
import { showPrice } from '@components/Orders/orderUtils';
import {
  addToCart,
  pushModifiersGroupData,
  setPosition,
} from '@reducers/orders';
import { LABEL } from '../../../../../veriables';
import style from './MenuItem.module.scss';
import { toggleOtherPaymentOption } from '@reducers/payment';
import {
  renderInitialData,
  updateExcludeModifier,
  applyModFunction,
  calculateModifierAmount,
  checkRequiredModifierCount,
} from './MenuItemHelper';
import { safeJsonParse } from '@utility/helperFunction';

const MenuItem = ({
  activeMenuItemId,
  data,
  auth,
  serverAppTheme,
  menuCard,
  modifierGroupsHashTable,
  modifiersHashTable,
  menuItemsHashTable,
  menuIndex,
  menusList,
  addToCart,
  pushModifiersGroupData,
  setPosition,
  openPricePopUp,
}) => {
  const navigate = useNavigate();
  const [cart, setCart] = useState(() =>
    getObjectValue(() => JSON.parse(window.sessionStorage.getItem('cart')), [])
  );

  const serverAppImage =
    data.menuItem?.serverAppAsImage && data.menuItem?.intermediateImageUrl
      ? `url(${data.menuItem?.intermediateImageUrl})`
      : '';

  const newItemStyle = useMemo(() => {
    const nameLength = data.menuItem?.name?.length || 0;
    return {
      itemStyle: {
        wordBreak: nameLength > 20 ? 'break-word' : 'normal',
        lineHeight: nameLength > 20 ? '1.2' : '',
        color: data.menuItem?.outOfStock
          ? '#A0A0A0'
          : serverAppTheme?.primary_text,
      },
      priceStyle: {
        color: serverAppTheme?.primary_text,
        paddingTop: '2px',
        height: serverAppImage && '97%',
      },
      displayPriceStyle: {
        color: data.menuItem?.outOfStock && '#A0A0A0',
      },
      menuItemStyle: {
        border: '1px solid #DDD',
      },
      countStyle: {
        color: serverAppTheme?.primary_text,
        background: serverAppTheme?.seat_box_text,
      },
    };
  }, [auth, data.menuItem, serverAppTheme, serverAppImage]);

  const menuItemClick = data => {
    if (data?.menuItem?.openPrice) {
      openPricePopUp(data);
      return;
    }

    const maxQuantity = data?.menuItem?.maxOrderQuantity;
    const minQuantity = data?.menuItem?.minOrderQuantity;
    const qty = maxQuantity || minQuantity;
    const { menuTypeId, menuItemId, price, internalId } = data;
    const itemInfo = menuCard[menuTypeId][menuItemId];
    const dataToSend = {
      quantity: 1,
      price: price || itemInfo?.price,
      menuItemId,
      menuTypeId,
      brandCourseId: itemInfo?.menuItem?.brandCourseId,
      modifiers: renderInitialData({
        menuItemsHashTable,
        modifierGroupsHashTable,
        modifiersHashTable,
        activeMenuItemId,
        menuItemId,
      }),
      note: null,
      menuItemName: (itemInfo?.menuItem || {})?.name,
      serverAppModifierGroupDisplayStyle:
        data?.serverAppModifierGroupDisplayStyle ?? 0,
    };
    console.log(dataToSend);
    let cartItem = updateExcludeModifier({
      cartItemsList: [dataToSend],
      menuItemsHashTable,
      modifierGroupsHashTable,
      modifiersHashTable,
    });

    cartItem = applyModFunction({
      cartItemsList: cartItem,
      modifierGroupsHashTable,
    });
    const modifierObject = getObjectValue(
      () =>
        mapStringCartToObject(
          cartItem,
          [],
          modifiersHashTable,
          modifierGroupsHashTable
        )[0].modifiers,
      []
    );
    dataToSend.modifierObject = modifierObject.filter(e => e.modifierGroupId);
    const modiferPrice = calculateModifierAmount({
      modifierData: [],
      modifierGroupsHashTable,
    });

    const { isTogo, isCallCenter } = getDeviceType();
    let position = safeJsonParse(window.sessionStorage.getItem('position'), {});
  
    if (isTogo && isCallCenter && !position?.seatId) {
      setPosition({ number: -1 });
      position = { number: -1 };
    }
   
    const requestData = {
      ...dataToSend,
      note: dataToSend?.note,
      pending: true,
      seatIds: position?.number === -1 ? [] : [position?.seatId],
      price: Number(dataToSend?.price) + modiferPrice,
      menuScreenId: Number(menuTypeId),
      // internalId,
      internalId: internalId ? internalId : new Date().getTime(),
      menuId: menusList[menuIndex]?.id,
      modifiers: dataToSend?.modifierObject,
      modifierData: dataToSend.modifiers,
    };
    // TODO: Check OpenPrice value later
    requestData.modifierJson = JSON.stringify({
      ...requestData,
      openPrice: false,
    });
    // eslint-disable-next-line
    const cartData = {
      ...requestData,
      isProcessing: true,
      openPrice: false,
    };
    console.log('Cart Data : ', cartData);
    addToCart(cartData);
  };
  return (
    <div
      className={cn('row mx-0 h-100')}
      style={{
        background: data.menuItem.serverAppButtonColor || '#dedede',
      }}
    >
      <TouchableDiv
        className={cn(
          style.oTextPrimary,
          'col-12 h-100 p-1 position-relative btn-ripple'
        )}
        role="presentation"
        onClick={event => {
          event.preventDefault();
          const { menuTypeId, menuItemId } = data;
          const requiredModLength = checkRequiredModifierCount({
            menuItemId,
            menuId: menusList[menuIndex].id,
            menuItemsHashTable,
            modifierGroupsHashTable,
          });
          if (data.menuItem?.linkType === 1) {
            navigate(
              `${APP_CONFIG.BASE_URL}/order-item/${menuTypeId}/${menuItemId}?menuId=${menusList[menuIndex].id}&parentMenuItemId=${menuItemId}`
            );
          } else if (requiredModLength === 0 && data.menuItem?.linkType !== 1 && !data.menuItem?.minOrderQuantity) {
            menuItemClick(data);
          } else {
            const modifierList = menuItemsHashTable[
              menuItemId
            ].modifierGroupLinks.map(item => {
              const modGroupLinks =
                modifierGroupsHashTable[item.modifierGroupId].modifierLinks;
              return {
                ...item,
                ...modifierGroupsHashTable[item.modifierGroupId],
                //For faster loading of modifier we load only few modifier initially
                modifierLinks: modGroupLinks.length > 20 ? [] : modGroupLinks,
                show: true,
              };
            });
            pushModifiersGroupData(modifierList).then(() => {
              window.sessionStorage.setItem(
                'serverAppModifierGroupDisplayStyle',
                data?.serverAppModifierGroupDisplayStyle ?? 0
              );
              navigate(
                `${
                  APP_CONFIG.BASE_URL
                }/order-item/${menuTypeId}/${menuItemId}?menuId=${
                  menusList[menuIndex].id
                }&orderType=order`
              );
            });
          }
        }}
        style={{
          ...newItemStyle.menuItemStyle,
          backgroundImage: serverAppImage,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          pointerEvents: data.menuItem?.outOfStock ? 'none' : 'auto'
        }}
      >
        {!(
          data.menuItem?.serverAppAsImage && data.menuItem?.intermediateImageUrl
        ) && (
          <div
            style={{
              ...newItemStyle.itemStyle,
              color: data.menuItem?.serverAppButtonFontColor
                ? data.menuItem?.serverAppButtonFontColor
                : newItemStyle.itemStyle?.color,
            }}
            className={cn('col-12 px-0  fs_14', style.itemNameClamp)}
          >
            {data.menuItem?.name}
          </div>
        )}
        <div
          className="col-12 px-0 h-35 d-flex fw-600"
          // style={newItemStyle.priceStyle}
          style={{
            ...newItemStyle.priceStyle,
            color: data.menuItem?.serverAppButtonFontColor
              ? data.menuItem?.serverAppButtonFontColor
              : newItemStyle.priceStyle?.color,
          }}
        >
          <div className="col-4 px-0 d-flex align-items-end" />
          <div
            className={cn('col-6 px-0 d-flex position-absolute')}
            style={{
              right: data.menuItem?.outOfStock ? '4px' : '-36px',
              bottom: data.menuItem?.outOfStock ? '16px' : '2px',
            }}
          >
            {data?.menuItem?.outOfStock ? (
              <div
                className={cn(
                  style.outOfStockNumber,
                  'fs-12 rounded fw-600 d-flex justify-content-center align-items-center',
                  style.outOfStockStyle
                )}
              >
                {LABEL().OUT_OF_STOCK_NUMBER}
              </div>
            ) : null}
          </div>
        </div>
      </TouchableDiv>
    </div>
  );
};

const mapStateToProps = ({ oauth, theme, orders }) => ({
  activeMenuItemId: Number(urlSearchParams('menuId')) || 0,
  auth: oauth.authInfo,
  serverAppTheme: theme.serverAppTheme,
  menuItemsHashTable: orders.menuItemsHashTable,
  menuCard: orders.menuCardList,
  menuIndex: orders.menuIndex,
  menusList: orders.menusList,
  modifierGroupsHashTable: orders.modifierGroupsHashTable,
  modifiersHashTable: orders.modifiersHashTable,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addToCart,
      pushModifiersGroupData,
      setPosition,
      toggleOtherPaymentOption,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null
)(memo(MenuItem));
